import { logWrapper } from '../utils';
import diacritics from 'diacritics';
import toastr from 'toastr';

export default {
  userModel: [
    'runtimeConstant',
    '$filter',
    '$rootScope',
    function (runtimeConstant, $filter, $rootScope) {
      var $scope = angular.element(document).scope();

      function User(data) {
        if (!data) {
          data = {
            Id: 0,
            IdPreference: 0,
            Name: '',
            CPF: '',
            Email: '',
            Phone: '',
            IsSysAdmin: false,
            IsBloqued: false,
            IsAutoLogin: false,
            ChangePass: true,
            EntraceHour: '',
            ExitHours: '',
            D4SignTokenApi: null,
            D4SignCriptKey: null,
            CertificataTokenApi: null,
          };
        }

        this.id = data.Id;
        this.idPreference = data.IdPreference;
        this.name = data.Name;
        this.cpf = data.Cpf;
        this.email = data.Email;
        this.phone = data.Phone;
        this.EntraceHour = data.EntraceHour;
        this.ExitHours = data.ExitHours;
        this.isSysAdmin = data.IsSysAdmin;
        this.isBloqued = data.IsBloqued;
        this.isAutoLogin = data.IsAutoLogin;
        this.autoLoginToken = data.AutologinToken;
        this.pass = data.Pass;
        this.userCompanies = data.Companies ? data.Companies : [];
        this.changePass = data.ChangePass;
        this.autoLoginUrl = this.autoLoginToken
          ? window.location.host + '/#/login/autologin/' + this.autoLoginToken
          : '';
        this.idFolderIntegration = data.idFolderIntegration;
        this.disableNotificationEmail = data.DisableNotificationEmail;

        var adminFeatures = [];
        if (data.AdminFeatures) {
          for (var i = 0, length = data.AdminFeatures.length; i < length; i++) {
            var af = data.AdminFeatures[i];
            adminFeatures.push({
              IdAdminFeature: af.IdAdminFeature,
              IdUser: af.IdUser,
            });
          }
        }
        this.adminFeatures = adminFeatures;
        $scope.adminFeatures = this.adminFeatures;

        this.selected = false;
        this.d4SignTokenApi = data.D4SignTokenApi;
        this.d4SignCriptKey = data.D4SignCriptKey;
        this.certificataTokenApi = data.CertificataTokenApi;
      }

      function title() {
        return this.name;
      }

      function details() {
        return this.email;
      }

      function tags() {
        var tags = [];

        if (this.isSysAdmin) {
          tags.push('Sys Admin');
        }

        if (this.isBloqued) {
          tags.push($filter('translate')('BLOCKED'));
        }

        if (this.EntraceHour !== undefined && this.ExitHours !== undefined) {
          tags.push(
            'Horário Permitido: ' + this.EntraceHour + ' / ' + this.ExitHours
          );
        }

        if (this.isAutoLogin) {
          tags.push('Auto login');
        }

        return tags;
      }

      function notifyAutologinCopy() {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr['info'](
          $filter('translate')($filter('translate')('LINK COPIED'))
        );
      }

      function getAutoLoginCode() {
        if (
          this.isAutoLogin &&
          (!this.autoLoginToken || this.autoLoginToken === '')
        ) {
          var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var code = '';
          for (var i = 0; i < 10; i++) {
            var pos = Math.floor(Math.random() * 35);
            //so para garantir que não vai dar problema
            if (pos < 0) {
              pos = 0;
            } else if (pos > 35) {
              pos = 35;
            }
            code += chars[pos];
          }
          this.autoLoginToken = code;
        }
        this.autoLoginUrl =
          'https://' +
          window.location.host +
          '/#/login/autologin/' +
          this.autoLoginToken;
      }

      function filteredCompanies(filter) {
        var f = diacritics.remove(filter).toLowerCase();
        if (this.allCompanies) {
          return this.allCompanies.filter(
            (item) => diacritics.remove(item.name).toLowerCase().indexOf(f) >= 0
          );
        }
      }

      function filteredGroups(filter) {
        var f = diacritics.remove(filter).toLowerCase();
        if (!this.allGroups) return null;
        return this.allGroups.filter(
          (item) => diacritics.remove(item.name).toLowerCase().indexOf(f) >= 0
        );
      }

      function companyHasAutoLogin() {
        if ($rootScope.user) {
          var lastCompany =
            $scope.user.userPreferences.IdLastCompany !== undefined
              ? $scope.user.userPreferences.IdLastCompany
              : 0;
          var company = $scope.user.companies.filter(function (c) {
            return c.IdCompany === lastCompany;
          })[0].Company;
          return company.HasAutoLogin;
        }
        return false;
      }

      function anyCompanySelected() {
        if (!this.allCompanies) {
          return false;
        }
        var companies = this.allCompanies.filter(function (c) {
          return c.selected;
        });
        return companies.length > 0;
      }

      function isValid() {
        var isValid =
          this.email &&
          this.name &&
          this.pass &&
          (this.id === 0 && this.isPassChanged
            ? this.pass === this.confirmPass && this.anyCompanySelected()
            : true);
        return isValid;
      }

      function selectAllCompanies() {
        for (var i = 0, length = this.allCompanies.length; i < length; i++) {
          this.allCompanies[i].selected =
            this.allCompanies[i].isEnabled() && this.checkboxAll;
        }
      }

      function selectAllGroups() {
        for (var i = 0, length = this.allGroups.length; i < length; i++) {
          this.allGroups[i].selected = this.checkboxAllGroups;
        }
      }

      function selectAllAdminFeatures() {
        for (
          var i = 0, length = this.allAdminFeatures.length;
          i < length;
          i++
        ) {
          this.allAdminFeatures[i].selected = this.checkboxAllAdminFeatures;
        }
      }

      function toogleAllGroups(value) {
        if (arguments.length > 0) {
          this.filteredGroups(this.groupFilter).forEach(function (d) {
            d.selected = value;
          });
        } else {
          if (
            this.filteredGroups(this.groupFilter) === undefined ||
            this.filteredGroups(this.groupFilter) === null
          ) {
            return false;
          }

          return this.filteredGroups(this.groupFilter).every(function (d) {
            return d.selected === true;
          });
        }
      }

      function toogleAllAdminFeatures(value) {
        if (arguments.length > 0) {
          this.allAdminFeatures.forEach(function (d) {
            d.selected = value;
          });
        } else {
          if (
            this.allAdminFeatures === undefined ||
            this.allAdminFeatures === null
          ) {
            return false;
          }

          return this.allAdminFeatures.every(function (d) {
            return d.selected === true;
          });
        }
      }

      function run() {
        try {
          User.prototype = {
            checkboxAll: false,

            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            notifyAutologinCopy: logWrapper(
              notifyAutologinCopy,
              runtimeConstant.isDebugModelsInternals
            ),
            getAutoLoginCode: logWrapper(
              getAutoLoginCode,
              runtimeConstant.isDebugModelsInternals
            ),
            filteredCompanies: logWrapper(
              filteredCompanies,
              runtimeConstant.isDebugModelsInternals
            ),
            filteredGroups: logWrapper(
              filteredGroups,
              runtimeConstant.isDebugModelsInternals
            ),
            companyHasAutoLogin: logWrapper(
              companyHasAutoLogin,
              runtimeConstant.isDebugModelsInternals
            ),
            anyCompanySelected: logWrapper(
              anyCompanySelected,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            selectAllCompanies: logWrapper(
              selectAllCompanies,
              runtimeConstant.isDebugModelsInternals
            ),
            selectAllGroups: logWrapper(
              selectAllGroups,
              runtimeConstant.isDebugModelsInternals
            ),
            selectAllAdminFeatures: logWrapper(
              selectAllAdminFeatures,
              runtimeConstant.isDebugModelsInternals
            ),
            toogleAllGroups: logWrapper(
              toogleAllGroups,
              runtimeConstant.isDebugModelsInternals
            ),
            toogleAllAdminFeatures: logWrapper(
              toogleAllAdminFeatures,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return User;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
